import { StyledButton } from "common/components/StyledElements";
import ArrowRight from "common/icons/arrow_right.svg";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const MainContainer = styled.div`
  display: flex;
  height: 60vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const TextContainer = styled.div`
  text-align: center;
  font-size: 2rem;
  margin-bottom: 3rem;
`;
const Img = styled.img`
  height: 24px;
  width: 24px;
  transform: rotate(180deg);
`;

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <MainContainer>
      <Helmet>Ennea Solutions</Helmet>
      <TextContainer>
        <h2>404</h2>
        <span>Page Not Found</span>
      </TextContainer>
      <StyledButton onClick={() => navigate("/")}>
        <Img src={ArrowRight} alt="Go Back to Ennea Solutions" />
        Go back
      </StyledButton>
    </MainContainer>
  );
};

export default NotFound;
